import QueryKeys from '@/utils/QueryKeys';
import { plato_api_program_states_path, plato_api_program_program_states_path } from '@/modules/routes';
import { UseQueryOptions } from '@tanstack/react-query';
import { BaseProgramState, ProgramStateSchema } from '@/types/api/v2/ProgramStateSchema';
import useApi from './useApi';

interface UseProgramStatesParams<K extends (keyof BaseProgramState)[]> {
  programId?: number;
  only?: K;
  params?: object;
}

type UseProgramStatesOptions<K extends (keyof BaseProgramState)[]> =
  UseProgramStatesParams<K> & Omit<UseQueryOptions<ProgramStateSchema<K[number]>[]>, 'queryFn' | 'queryKey'>;

export default function useProgramStates<K extends(keyof BaseProgramState)[]>({
  programId,
  only,
  params = {},
  ...queryOptions
}: UseProgramStatesOptions<K> = {} as UseProgramStatesOptions<K>) {
  const endpoint = programId
    ? plato_api_program_program_states_path(programId, { only })
    : plato_api_program_states_path({ only });

  return useApi<ProgramStateSchema<K[number]>[], BaseProgramState, K, never, []>({
    endpoint,
    extra_attributes: [] as any,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.ProgramStates, programId, only],
    ...queryOptions,
  });
}
